import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export function Reveal({
  children,
  delay = 0,
  y = 36,
  className = "",
  once = true,
  amount = 0.2,
}) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount }}
      transition={{ duration: 1.1, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

/* Masked line-by-line headline reveal */
export function MaskedLines({
  lines,
  className = "",
  lineClassName = "",
  delay = 0,
  stagger = 0.14,
  start = true,
}) {
  return (
    <span className={`block ${className}`}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block will-change-transform ${lineClassName}`}
            initial={{ y: "115%", rotate: 2.5 }}
            animate={start ? { y: "0%", rotate: 0 } : { y: "115%", rotate: 2.5 }}
            transition={{
              duration: 1.25,
              delay: delay + i * stagger,
              ease: EASE,
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

/* Scroll-linked parallax wrapper */
export { EASE };
